<template>
  <div>
    <SubletInput
      v-model="activeCurrentTenant.name"
      label="Namn"
      placeholder="Namn"
      :description="
        activeIndexIsOne
          ? 'Ange för- och efternamn på dig som hyr ut'
          : 'Ange för- och efternamn på medboende'
      "
      autocomplete="given-name"
    />
    <Fieldset>
      <SubletInput
        v-model="activeCurrentTenant.email"
        label="E-post"
        placeholder="E-post"
        :description="
          activeIndexIsOne
            ? 'Ange din e-postadress'
            : 'Ange e-postadress till medboende'
        "
        type="email"
        :validation="validEmail"
        error-text="E-postadress måste anges på detta vis: adress@mailhost.com"
        autocomplete="email"
      />
      <SubletInput
        v-model="activeCurrentTenant.phone"
        label="Telefonnummer"
        placeholder="Telefonnummer"
        :description="
          activeIndexIsOne
            ? 'Ange ditt telefonnummer'
            : 'Ange telefonnummer till medboende'
        "
        error-text="Fältet får endast innehålla siffror"
        :validation="validateNumber"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="tel"
      />
    </Fieldset>
    <SubletInput
      v-if="!onCurrentContractExists"
      v-model="activeCurrentTenant.ssn"
      label="Personnummer"
      placeholder="Personnummer"
      :description="
        activeIndexIsOne
          ? 'Ange ditt personnummer'
          : 'Ange personnummer för medboende'
      "
      :error-text="ssnErrorText"
      :validation="validateSsn"
    />
    <Fieldset v-else>
      <SubletInput
        v-model="activeCurrentTenant.ssn"
        label="Personnummer"
        placeholder="Personnummer"
        :description="
          activeIndexIsOne
            ? 'Ange ditt personnummer'
            : 'Ange personnummer för medboende'
        "
        :error-text="ssnErrorText"
        :validation="validateSsn"
      />
      <Checkbox
        v-model="activeOnCurrentContract"
        class="s-checkbox"
        name="activeOnCurrentContract"
        :checked="activeOnCurrentContract"
        :is-disabled="!applicationIsEditable"
        @change="activeOnCurrentContract = !activeOnCurrentContract"
        >Jag står på hyreskontraktet</Checkbox
      >
    </Fieldset>
    <ProtectedIdentityInput
      :is-disabled="!applicationIsEditable"
      :protected-identity-val="!!activeCurrentTenant.protectedIdentity"
      :active-index="activeIndex"
      :margin="true"
      @update="updateProtectedIdentity"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  validEmail,
  validateNumber,
  validatePersonalNumber
} from '@/utils/input-validations';

import Fieldset from '@/components/Fieldset.vue';
import SubletInput from '@/components/SubletInput.vue';
import Checkbox from '@/components/Checkbox.vue';
import ProtectedIdentityInput from '@/components/ProtectedIdentityInput.vue';

export default {
  name: 'AhCurrentTenantFields',
  components: {
    Fieldset,
    SubletInput,
    Checkbox,
    ProtectedIdentityInput
  },
  props: {
    currentTenants: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      ssnErrorText:
        'Personnummer måste anges med 10 siffror, t.ex. YYMMDD-XXXX',
      validEmail,
      validateNumber,
      validatePersonalNumber
    };
  },
  computed: {
    ...mapGetters({
      applicationIsEditable: 'subletApplication/applicationIsEditable'
    }),
    activeIndexIsOne() {
      return this.activeIndex === 0;
    },
    onCurrentContractExists() {
      return this.activeCurrentTenant.hasOwnProperty('onCurrentContract');
    },
    activeCurrentTenant: {
      get() {
        return this.currentTenants[this.activeIndex];
      },
      set() {
        this.$emit();
      }
    },
    activeOnCurrentContract: {
      get() {
        return (
          this.currentTenants[this.activeIndex]?.onCurrentContract || false
        );
      },
      set(newValue) {
        this.$set(
          this.currentTenants[this.activeIndex],
          'onCurrentContract',
          newValue ? 1 : 0
        );
      }
    }
  },
  methods: {
    updateProtectedIdentity(value) {
      const newValue = value ? 1 : 0;
      if (newValue !== this.activeCurrentTenant.protectedIdentity) {
        this.$emit('isEditing');
      }
      this.activeCurrentTenant.protectedIdentity = newValue;
    },
    validateSsn(value) {
      if (!validatePersonalNumber(value)) {
        this.ssnErrorText = 'Det personnummer du angivit är inte giltigt';
        return false;
      }
      return validatePersonalNumber(value);
    }
  }
};
</script>
<style scoped lang="scss">
.s-checkbox {
  margin-bottom: 0;
  @include mobile {
    margin-bottom: 4.8rem;
  }
}
</style>
